// @ts-check

/** @param {string[]} categories */
const createAssetType = (categories) => {
	if (categories.includes('NocworxOpenstack')) return 'open stack';
	if (categories.includes('AutoDedicated')) return 'bare metal';
	if (categories.includes('StrictDedicated')) return 'dedicated';
	if (
		categories.includes('CloudVPS') ||
		categories.includes('CloudBareMetal') ||
		categories.includes('PrivateParent') ||
		categories.includes('BeyondHostingVPS') ||
		categories.includes('VirtualDedicated')
	)
		return 'cloud';
	if (categories.includes('DNS')) return 'dns_zone';
	if (categories.includes('SSL')) return 'ssl';

	return 'asset';
};

export default createAssetType;
